export default __webpack_public_path__ + "static/media/Mark-4-Suit-06.099cc88d.jpg";